import React from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const NoAnswer = () => {

    let classColor = "card bg-gradient-primary" ;
    let classButton = "primary  bg-gradient-primary"  + " border border-0 rounded-pill"
  
  return (
    <div className="card99">
       <div className={classColor}>
                <div className="card-body">
                <div className="row ">
                    <div className="col centerCard111 ">
                    <span className="h3 font-weight-bold mb-0 text-white centerCard1">no new answers</span>
                    <p className="card-text  navText2">
                     </p>
                    </div>
                    <div className="col-auto cardIcon">
                    <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                        <i className="ni ni-spaceship"></i>
                    </div>
                    </div>
                </div>
                <p className="mt-0 mb-0 text-sm text-center">
                <LinkContainer to={`/studentasknew/`} className='btn btn-default'>
                    <Button variant={classButton}> &nbsp; Ask a new question &nbsp;</Button>
                </LinkContainer>
                </p>
                </div>
        </div>
      
    </div>
  )
}

export default NoAnswer
